import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import { fetchTemplates, removeTemplate, selectTemplates, selectTemplatesErrors, selectTemplatesPageInfo, selectTemplatesRefetchFlags, selectTemplatesStatus, } from 'store/parameters/templatesSlice';
import ParametersTable from '../shared/ParametersTable';
function Templates({ toolbar }) {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const templates = useSelector(selectTemplates);
    const pageInfo = useSelector(selectTemplatesPageInfo);
    const status = useSelector(selectTemplatesStatus);
    const errors = useSelector(selectTemplatesErrors);
    const refetchFlags = useSelector(selectTemplatesRefetchFlags);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(fetchTemplates());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchTemplates());
        }
    }, [dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (templateId) => {
        dispatch(removeTemplate(templateId));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } }, toolbar),
        templates.length === 0 ? (React.createElement(EmptyState, null)) : (React.createElement(ParametersTable, { columns: [
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [{ content: t('common:name') }, { content: null }], dataLength: templates.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, templates.map((template) => (React.createElement(Row, { key: template.id },
            React.createElement(Cell, null, template.name),
            React.createElement(Cell, null,
                React.createElement(Dropdown, null,
                    React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: () => dispatch(openModal({ name: 'templateEditor', id: template.id })) }, t('common:edit')),
                    React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(template.id) }, t('common:delete')))))))))));
}
export default memo(Templates);
